import {z} from 'zod'

export type ICalEventId = `ical-${string}`
export const ICalEventId = z.string().startsWith('ical-') as z.ZodType<ICalEventId>
